import axios from 'axios';

export default axios.create({
  //baseURL: `/ api/1/`
  baseURL: process.env.REACT_APP_API_URL
});